import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * L'accueil, c'est le planning : l'écran de travail de tout le monde. On y part avant tout
 * rendu — y compris au retour d'une invitation, que Keycloak renvoie à la racine une fois
 * le mot de passe choisi. Le garde de /_connecte s'occupe ensuite de la connexion.
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/planning", replace: true });
  },
});
